import { IconTextDescriptionCombinedProps } from './types';

const usePresenter = (props: IconTextDescriptionCombinedProps): IconTextDescriptionCombinedProps => {
  return props;
};

export default usePresenter;
